import React, { Component } from "react";

import { PayPalButton } from "react-paypal-button-v2";
import { auth, firestore } from "../../db/config";
import moment from "moment";
class PayButton extends Component {
  state = {
    userId: "",
  };
  componentDidMount() {
    auth.onAuthStateChanged((user) => {
      this.setState({
        userId: user.uid,
      });
    });
  }
  render() {
    // console.log(String(this.props.amount));

    return (
      <PayPalButton
        amount={this.props.amount}
        // shippingPreference="NO_SHIPPING" // default is "GET_FROM_FILE"
        onSuccess={(details, data) => {
          firestore
            .collection("deposit")
            .add({
              ...this.props.investmentPlan,
              amount: this.props.amount,
              investmentTime: moment().format("MMMM Do YYYY, h:mm:ss a"),
              paymentType: "payPal",
              status: "pending",
              userId: this.state.userId,
            })
            .then(() => {
              alert(
                "Transaction for " +
                  this.props.investmentPlan.planName +
                  " is completed by " +
                  details.payer.name.given_name
              );
              window.location.href = "/deposit";
            });
          // OPTIONAL: Call your server to save the transaction
          return fetch("/paypal-transaction-complete", {
            method: "post",
            body: JSON.stringify({
              orderID: data.orderID,
            }),
          });
        }}
      />
    );
  }
}
export default PayButton;
